import { EXTRA_CITIES } from "@/data/cities-expansion";

export const PROVINCES = [
  {
    code: "ON", name: "Ontario", slug: "ontario", capital: "Toronto",
    blurb: "Ontario's mix of downtown condos, sprawling suburbs, and lake-effect weather off the Great Lakes creates year-round cleaning demand.",
    cities: [
      { name: "Toronto", slug: "toronto", pop: "2,794,356" },
      { name: "Ottawa", slug: "ottawa", pop: "1,017,449" },
      { name: "Mississauga", slug: "mississauga", pop: "717,961" },
      { name: "Brampton", slug: "brampton", pop: "656,480" },
      { name: "Hamilton", slug: "hamilton", pop: "569,353" },
      { name: "London", slug: "london", pop: "422,324" },
      { name: "Markham", slug: "markham", pop: "338,503" },
      { name: "Vaughan", slug: "vaughan", pop: "323,103" },
      { name: "Kitchener", slug: "kitchener", pop: "256,880" },
      { name: "Windsor", slug: "windsor", pop: "229,660" },
      { name: "Oshawa", slug: "oshawa", pop: "175,383" },
      { name: "Greater Sudbury", slug: "sudbury", pop: "166,004" },
      { name: "Barrie", slug: "barrie", pop: "147,829" },
      { name: "Guelph", slug: "guelph", pop: "143,740" },
      { name: "Cambridge", slug: "cambridge", pop: "138,479" },
      { name: "St. Catharines", slug: "st-catharines", pop: "136,803" },
      { name: "Kingston", slug: "kingston", pop: "132,485" },
      { name: "Niagara Falls", slug: "niagara-falls", pop: "94,415" },
      { name: "Peterborough", slug: "peterborough", pop: "83,651" },
      { name: "Sault Ste. Marie", slug: "sault-ste-marie", pop: "72,051" },
      { name: "North Bay", slug: "north-bay", pop: "51,553" },
    ],
  },
  {
    code: "BC", name: "British Columbia", slug: "british-columbia", capital: "Victoria",
    blurb: "British Columbia's coastal rain, mountain communities, and fast-growing metro regions keep homes and businesses battling moisture, mud, and mildew.",
    cities: [
      { name: "Vancouver", slug: "vancouver", pop: "662,248" },
      { name: "Surrey", slug: "surrey", pop: "568,322" },
      { name: "Burnaby", slug: "burnaby", pop: "249,125" },
      { name: "Richmond", slug: "richmond", pop: "209,937" },
      { name: "Abbotsford", slug: "abbotsford", pop: "153,524" },
      { name: "Coquitlam", slug: "coquitlam", pop: "148,625" },
      { name: "Kelowna", slug: "kelowna", pop: "144,576" },
      { name: "Langley", slug: "langley", pop: "132,603" },
      { name: "Nanaimo", slug: "nanaimo", pop: "99,863" },
      { name: "Kamloops", slug: "kamloops", pop: "97,902" },
      { name: "Chilliwack", slug: "chilliwack", pop: "93,203" },
      { name: "Victoria", slug: "victoria", pop: "91,867" },
      { name: "Prince George", slug: "prince-george", pop: "76,708" },
    ],
  },
  {
    code: "AB", name: "Alberta", slug: "alberta", capital: "Edmonton",
    blurb: "Alberta's boom-town construction, dusty chinook winds, and long winters tracked indoors make professional cleaning a practical necessity.",
    cities: [
      { name: "Calgary", slug: "calgary", pop: "1,306,784" },
      { name: "Edmonton", slug: "edmonton", pop: "1,010,899" },
      { name: "Lethbridge", slug: "lethbridge", pop: "101,482" },
      { name: "Red Deer", slug: "red-deer", pop: "100,844" },
      { name: "Airdrie", slug: "airdrie", pop: "74,410" },
      { name: "Fort McMurray", slug: "fort-mcmurray", pop: "68,002" },
      { name: "Grande Prairie", slug: "grande-prairie", pop: "64,141" },
      { name: "Medicine Hat", slug: "medicine-hat", pop: "63,271" },
    ],
  },
  {
    code: "QC", name: "Quebec", slug: "quebec", capital: "Quebec City",
    blurb: "Quebec's historic architecture, harsh freeze-thaw winters, and dense urban neighbourhoods demand cleaning crews who understand older buildings and four true seasons.",
    cities: [
      { name: "Montreal", slug: "montreal", pop: "1,762,949" },
      { name: "Quebec City", slug: "quebec-city", pop: "549,459" },
      { name: "Laval", slug: "laval", pop: "438,366" },
      { name: "Gatineau", slug: "gatineau", pop: "291,041" },
      { name: "Longueuil", slug: "longueuil", pop: "254,483" },
      { name: "Sherbrooke", slug: "sherbrooke", pop: "172,950" },
      { name: "Lévis", slug: "levis", pop: "149,683" },
      { name: "Saguenay", slug: "saguenay", pop: "144,746" },
      { name: "Trois-Rivières", slug: "trois-rivieres", pop: "139,163" },
      { name: "Terrebonne", slug: "terrebonne", pop: "119,944" },
    ],
  },
  {
    code: "NS", name: "Nova Scotia", slug: "nova-scotia", capital: "Halifax",
    blurb: "Nova Scotia's salty Atlantic air and storm seasons mean entryways, windows, and floors need consistent professional attention.",
    cities: [
      { name: "Halifax", slug: "halifax", pop: "439,819" },
      { name: "Dartmouth", slug: "dartmouth", pop: "96,054" },
      { name: "Lower Sackville", slug: "lower-sackville", pop: "28,398" },
      { name: "Cole Harbour", slug: "cole-harbour", pop: "25,600" },
      { name: "Bedford", slug: "bedford", pop: "24,577" },
      { name: "Eastern Passage", slug: "eastern-passage", pop: "12,743" },
      { name: "Fall River", slug: "fall-river", pop: "11,526" },
      { name: "Timberlea", slug: "timberlea", pop: "7,683" },
      { name: "Sydney", slug: "sydney", pop: "30,170" },
      { name: "Truro", slug: "truro", pop: "12,954" },
    ],
  },
  {
    code: "MB", name: "Manitoba", slug: "manitoba", capital: "Winnipeg",
    blurb: "Manitoba's extreme temperature swings — from slushy springs to dusty summers — track the outdoors inside all year long.",
    cities: [
      { name: "Winnipeg", slug: "winnipeg", pop: "749,607" },
      { name: "The Pas", slug: "the-pas", pop: "5,639" },
      { name: "Dauphin", slug: "dauphin", pop: "8,368" },
      { name: "Flin Flon", slug: "flin-flon", pop: "4,940" },
      { name: "Swan River", slug: "swan-river", pop: "4,049" },
      { name: "Snow Lake", slug: "snow-lake", pop: "1,088" },
      { name: "Gillam", slug: "gillam", pop: "1,007" },
      { name: "Brandon", slug: "brandon", pop: "51,313" },
      { name: "Steinbach", slug: "steinbach", pop: "17,806" },
    ],
  },
  {
    code: "SK", name: "Saskatchewan", slug: "saskatchewan", capital: "Regina",
    blurb: "Saskatchewan's prairie dust, harvest seasons, and long winters make regular professional cleaning essential for homes and workplaces.",
    cities: [
      { name: "Saskatoon", slug: "saskatoon", pop: "266,141" },
      { name: "Regina", slug: "regina", pop: "226,404" },
      { name: "Prince Albert", slug: "prince-albert", pop: "37,756" },
      { name: "Moose Jaw", slug: "moose-jaw", pop: "33,665" },
    ],
  },
  {
    code: "NB", name: "New Brunswick", slug: "new-brunswick", capital: "Fredericton",
    blurb: "New Brunswick's coastal humidity and snowy winters create steady demand for thorough, season-aware cleaning.",
    cities: [
      { name: "Moncton", slug: "moncton", pop: "79,470" },
      { name: "Saint John", slug: "saint-john", pop: "69,895" },
      { name: "Fredericton", slug: "fredericton", pop: "63,116" },
      { name: "Dieppe", slug: "dieppe", pop: "28,114" },
    ],
  },
  {
    code: "NL", name: "Newfoundland and Labrador", slug: "newfoundland-and-labrador", capital: "St. John's",
    blurb: "Newfoundland and Labrador's rugged weather and salt-heavy air are tough on interiors, windows, and floors.",
    cities: [
      { name: "St. John's", slug: "st-johns", pop: "110,525" },
      { name: "Mount Pearl", slug: "mount-pearl", pop: "22,957" },
      { name: "Corner Brook", slug: "corner-brook", pop: "19,333" },
    ],
  },
  {
    code: "PE", name: "Prince Edward Island", slug: "prince-edward-island", capital: "Charlottetown",
    blurb: "Prince Edward Island's red soil and tourist-season turnover keep cleaners busy from spring through fall.",
    cities: [
      { name: "Charlottetown", slug: "charlottetown", pop: "38,809" },
      { name: "Summerside", slug: "summerside", pop: "16,001" },
    ],
  },
  {
    code: "YT", name: "Yukon", slug: "yukon", capital: "Whitehorse",
    blurb: "Yukon's long winters and dusty summers mean mudrooms and entryways work overtime.",
    cities: [{ name: "Whitehorse", slug: "whitehorse", pop: "28,201" }],
  },
  {
    code: "NT", name: "Northwest Territories", slug: "northwest-territories", capital: "Yellowknife",
    blurb: "The Northwest Territories' extreme seasons bring ice, slush, and dust indoors for much of the year.",
    cities: [{ name: "Yellowknife", slug: "yellowknife", pop: "20,340" }],
  },
  {
    code: "NU", name: "Nunavut", slug: "nunavut", capital: "Iqaluit",
    blurb: "Nunavut's remote communities and harsh climate make dependable, professional cleaning support especially valuable.",
    cities: [{ name: "Iqaluit", slug: "iqaluit", pop: "7,429" }],
  },
].map((p) => (EXTRA_CITIES[p.slug] ? { ...p, cities: [...p.cities, ...EXTRA_CITIES[p.slug]] } : p));

export const ALL_CITIES = PROVINCES.flatMap((p) =>
  p.cities.map((c) => ({ ...c, province: p }))
);
export const CITY_COUNT = ALL_CITIES.length;
